import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Login from "./Admin/pages/Login";
// import { BlogProvider } from './fetchdata/BlogContext';

import Dashboard from "./Admin/pages/Dashboard";
import Addblog from "./Admin/pages/Blogs/Addblog";
import AddGallery from "./Admin/pages/Gallery/addGallery";
import BuildBlogs from "./Admin/pages/builder/buildBlogs";
import AdminAllBlogs from "./Admin/pages/Blogs/AllBlogs";
import EditAdminBlogs from "./Admin/pages/Blogs/EditAdminBlogs";
import AllCategory from "./Admin/pages/category/AllCategory";
import EditCategory from "./Admin/pages/category/EditCategory";
import AddCategory from "./Admin/pages/category/AddCategory";
import AllProduct from "./Admin/pages/product/AllProduct";
import EditProduct from "./Admin/pages/product/EditProduct";
import AddProduct from "./Admin/pages/product/AddProduct";

import AddAttribute from "./Admin/pages/attribute/AddAttribute";
import EditAttribute from "./Admin/pages/attribute/EditAttribute";
import AllAttribute from "./Admin/pages/attribute/AllAttribute";

import AddSpecialization from "./Admin/pages/specialization/AddSpecialization";
import EditSpecialization from "./Admin/pages/specialization/EditSpecialization";
import AllSpecialization from "./Admin/pages/specialization/AllSpecialization";

import AddDepartment from "./Admin/pages/department/AddDepartment";
import EditDepartment from "./Admin/pages/department/EditDepartment";
import AllDepartment from "./Admin/pages/department/AllDepartment";

import AddInterested from "./Admin/pages/interested/AddInterested";
import EditInterested from "./Admin/pages/interested/EditInterested";
import AllInterested from "./Admin/pages/interested/AllInterested";

import AddBusiness from "./Admin/pages/Business/AddBusiness";
import EditBusiness from "./Admin/pages/Business/EditBusiness";
import AllBusiness from "./Admin/pages/Business/AllBusiness";

import AddTag from "./Admin/pages/tag/AddTag";
import EditTag from "./Admin/pages/tag/EditTag";
import AllTag from "./Admin/pages/tag/AllTag";

import MenuBuilder from "./Admin/pages/builder/MenuBuilder";
import FooterMenuBuilder from "./Admin/pages/builder/FooterMenuBuilder";

import HomeLayout from "./Admin/pages/home/HomeLayout";
import AllReview from "./Admin/pages/review/AllReview";
import AllOrder from "./Admin/pages/order/AllOrder";
import PendingOrder from "./Admin/pages/order/PendingOrder";
import CompleteOrder from "./Admin/pages/order/CompleteOrder";

import AllUser from "./Admin/pages/user/AllUser";
import AllUserDoctor from "./Admin/pages/user/AllUserDoctor";
import UserView from "./Admin/pages/user/UserView";
import ThemeSetting from "./Admin/pages/home/ThemeSetting";

import AllZones from "./Admin/pages/zones/AllZones";
import EditZones from "./Admin/pages/zones/EditZones";
import AddZones from "./Admin/pages/zones/AddZones";

import AllTax from "./Admin/pages/tax/AllTax";
import EditTax from "./Admin/pages/tax/EditTax";
import AddTax from "./Admin/pages/tax/AddTax";

import AllPromo from "./Admin/pages/promo/AllPromo";
import EditPromo from "./Admin/pages/promo/EditPromo";
import AddPromo from "./Admin/pages/promo/AddPromo";
import OrderView from "./Admin/pages/order/OrderView";

import AddPage from "./Admin/pages/pages/AddPage";
import AllPage from "./Admin/pages/pages/AllPage";
import EditPage from "./Admin/pages/pages/EditPage";
import AllImages from "./Admin/pages/Gallery/AllImages";
import AllEnquire from "./Admin/pages/enquire/AllEnquire";

import Forgot from "./Admin/pages/Forgot";
import ProfileDoctorPending from "./Admin/pages/user/ProfileDoctorPending";
import ProfileHospitalPending from "./Admin/pages/user/ProfileHospitalPending";
import ProfileVendorPending from "./Admin/pages/user/ProfileVendorPending";

import ProfileEdit from "./Admin/pages/user/ProfileEdit";

import Admin404 from "./Admin/pages/Admin404";
import AdminLoader from "./Admin/pages/AdminLoader";
import getCookie from "./helpers/getCookie";
import getDecryptData from "./helpers/getDecryptData";

import { Toaster } from "react-hot-toast";

import getUserData from "./helpers/userAuth";
import AllUserVendor from "./Admin/pages/user/AllUserVendor";
import AllUserHospital from "./Admin/pages/user/AllUserHospital";

import JobView from "./Admin/pages/job/JobView";

import AllVendorEnquire from "./Admin/pages/enquire/AllVendorEnquire";

import { ThemeProvider } from "./fetchdata/ThemeContext";
import AllDoctorEnquire from "./Admin/pages/enquire/AllDoctorEnquire";
import AllHospitalEnquire from "./Admin/pages/enquire/AllHospitalEnquire";
import ProfileVendorView from "./Admin/pages/user/ProfileVendorView";
import ProfileHospitalView from "./Admin/pages/user/ProfileHospitalView";
import ProfileDoctorView from "./Admin/pages/user/ProfileDoctorView";
import AllPlansCard from "./Admin/pages/plans/AllPlansCard";
import AddJob from "./Admin/pages/job/AddJob";
import AddSkill from "./Admin/pages/skill/AddSkill";
import AllSkill from "./Admin/pages/skill/AllSkill";
import EditSkill from "./Admin/pages/skill/EditSkill";
import AllJob from "./Admin/pages/job/AllJob";
import AllJobDoctor from "./Admin/pages/job/AllJobDoctor";
import AllJobMyJob from "./Admin/pages/job/AllJobMyJob";
import SignupUserType from "./Admin/pages/user/SignupUserType";
import RecruiterDashboard from "./Admin/pages/recruiter/RecruiterDashboard";
import RecruiterJobs from "./Admin/pages/recruiter/RecruiterJobs";
import RecruiterJobForm from "./Admin/pages/recruiter/RecruiterJobForm";
import RecruiterApplicants from "./Admin/pages/recruiter/RecruiterApplicants";
import SeekerDashboard from "./Admin/pages/seeker/SeekerDashboard";
import SeekerJobs from "./Admin/pages/seeker/SeekerJobs";
import SeekerApplications from "./Admin/pages/seeker/SeekerApplications";
import SeekerSavedJobs from "./Admin/pages/seeker/SeekerSavedJobs";
import PortalPlansPage from "./Admin/pages/plans/PortalPlansPage";
import AdminSubscriptionOrdersPage from "./Admin/pages/plans/AdminSubscriptionOrdersPage";
import NotificationCenter from "./Admin/pages/notifications/NotificationCenter";
import PublicHome from "./Public/pages/PublicHome";
import PublicJobs from "./Public/pages/PublicJobs";
import PublicJobDetail from "./Public/pages/PublicJobDetail";
import PublicCompany from "./Public/pages/PublicCompany";
import PublicCmsPage from "./Public/pages/PublicCmsPage";
import PublicContactPage from "./Public/pages/PublicContactPage";
import PublicBlogs from "./Public/pages/PublicBlogs";
import PublicBlogDetail from "./Public/pages/PublicBlogDetail";
import AdminUsersPage from "./Admin/pages/jobportal/AdminUsersPage";
import AdminJobsPage from "./Admin/pages/jobportal/AdminJobsPage";
import AdminApplicationsPage from "./Admin/pages/jobportal/AdminApplicationsPage";
import PublicSignupUser from "./Public/pages/PublicSignupUser";
import DatabaseTransfer from "./Admin/pages/database/DatabaseTransfer";

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

function mysetCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function mygetCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function App() {
  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);

  const syncAuthState = async (sessionOverride) => {
    const mydata =
      sessionOverride !== undefined ? sessionOverride : await getDecryptData();
    setIsUserAuthenticated(Boolean(mydata));
    setisUsertype(mydata ? mydata.type : null);
  };

  useEffect(() => {
    const fetchData = async () => {
      await syncAuthState();
 
      console.log("auth sync", isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [location.pathname]);

  useEffect(() => {
    const handleAuthChange = (event) => {
      syncAuthState(event?.detail ?? null);
    };

    window.addEventListener("ynb-auth-changed", handleAuthChange);
    return () => window.removeEventListener("ynb-auth-changed", handleAuthChange);
  }, []);

  useEffect(() => {
    // Dynamically create a <link> element to load the CSS file
    const linkElement = document.createElement("link");
    linkElement.rel = "stylesheet";
    linkElement.href = "../assets/css/volt.css"; // Adjust the path as needed
    document.head.appendChild(linkElement);
    getUserData();
  }, []);

  return (
    <>
      <ThemeProvider>
        <Toaster />
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/jobs" element={<PublicJobs />} />
          <Route path="/jobs/:id" element={<PublicJobDetail />} />
          <Route path="/companies/:slug" element={<PublicCompany />} />
          <Route path="/about-us" element={<PublicCmsPage />} />
          <Route path="/contact-us" element={<PublicContactPage />} />
          <Route path="/page/:slug" element={<PublicCmsPage />} />
          <Route path="/career-advice" element={<PublicBlogs />} />
          <Route path="/blogs" element={<PublicBlogs />} />
          <Route path="/blogs/:slug" element={<PublicBlogDetail />} />
          <Route path="/:slug" element={<PublicCmsPage />} />
          <Route path="/forgot" element={<Forgot />} />

          <Route
            path="/dashboard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Navigate to="/vendor/dashboard" />) ||
                  (isUsertype === 0 && <Dashboard />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/vendor/dashboard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <RecruiterDashboard />
                  )) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recruiter/dashboard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <RecruiterDashboard />
                  )) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recruiter/jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <RecruiterJobs />
                  )) ||
                  (isUsertype === 0 && <Navigate to="/all-job" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recruiter/jobs/new"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <RecruiterJobForm />
                  )) ||
                  (isUsertype === 0 && <Navigate to="/add-job" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recruiter/jobs/:id/edit"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <RecruiterJobForm />
                  )) ||
                  (isUsertype === 0 && <Navigate to="/all-job" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recruiter/jobs/:id/applicants"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <RecruiterApplicants />
                  )) ||
                  (isUsertype === 0 && <Navigate to="/all-job" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/recruiter/plans"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  ((isUsertype === 1 || isUsertype === 3) && (
                    <PortalPlansPage />
                  )))) || <Navigate to="/" />
            }
          />
          <Route
            path="/recruiter/profile"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <ProfileVendorPending />) ||
                  (isUsertype === 3 && <ProfileHospitalPending />) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/job-seeker/dashboard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 2 && <SeekerDashboard />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/job-seeker/plans"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 2 && <PortalPlansPage />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/job-seeker/profile"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 2 && <ProfileDoctorPending />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/job-seeker/jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 2 && <SeekerJobs />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/job-seeker/applications"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 2 && <SeekerApplications />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/job-seeker/saved-jobs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 2 && <SeekerSavedJobs />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/profile/doctor/pending"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && isUsertype !== 2 && (
                  <AdminLoader />
                )) ||
                  (isUsertype === 1 && <Navigate to="/vendor/dashboard" />) ||
                  (isUsertype === 2 && <ProfileDoctorPending />))) || (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/profile/job-seeker/pending"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 3 && isUsertype !== 2 && (
                  <AdminLoader />
                )) ||
                  (isUsertype === 1 && <Navigate to="/vendor/dashboard" />) ||
                  (isUsertype === 2 && <ProfileDoctorPending />))) || (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/profile/vendor/pending"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 3 &&
                  isUsertype !== 2 && <AdminLoader />) ||
                  (isUsertype === 1 && <ProfileVendorPending />) ||
                  (isUsertype === 2 && (
                    <Navigate to="/vendor/dashboard" />
                  )))) || <Navigate to="/" />
            }
          />

          <Route
            path="/profile/hospital/pending"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 2 &&
                  isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <Navigate to="/vendor/dashboard" />) ||
                  (isUsertype === 2 && (
                    <Navigate to="/profile/doctor/pending" />
                  )) ||
                  (isUsertype === 3 && <ProfileHospitalPending />) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || (
                <Login />
              )
            }
          />
          <Route
            path="/profile/recruiter/pending"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 2 &&
                  isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <Navigate to="/vendor/dashboard" />) ||
                  (isUsertype === 2 && (
                    <Navigate to="/profile/job-seeker/pending" />
                  )) ||
                  (isUsertype === 3 && <ProfileHospitalPending />) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || (
                <Login />
              )
            }
          />
          <Route
            path="/all-vendor-enquire"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 2 &&
                  isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllVendorEnquire />) ||
                  (isUsertype === 2 && <AdminLoader />) ||
                  (isUsertype === 3 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Login />
            }
          />

          <Route
            path="/all-doctor-enquire"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 2 &&
                  isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 2 && <AllDoctorEnquire />) ||
                  (isUsertype === 3 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Login />
            }
          />

          <Route
            path="/all-hospital-enquire"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 2 &&
                  isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 2 && <AdminLoader />) ||
                  (isUsertype === 3 && <AllHospitalEnquire />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Login />
            }
          />

          <Route
            path="/profile/edit"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 0 &&
                  isUsertype !== 1 &&
                  isUsertype !== 2 &&
                  isUsertype !== 3 && <AdminLoader />) ||
                  (isUsertype === 1 && <ProfileEdit />) ||
                  (isUsertype === 2 && <ProfileEdit />) ||
                  (isUsertype === 3 && <ProfileEdit />) ||
                  (isUsertype === 0 && <ProfileEdit />))) || <Login />
            }
          />

          <Route path="/addblog" element={<Addblog />} />
          <Route path="/add-gallery" element={<AddGallery />} />
          <Route path="/buildBlogs/:slug" element={<BuildBlogs />} />
          <Route path="/allblogs" element={<AdminAllBlogs />} />
          <Route path="/edit-blog/:slug" element={<EditAdminBlogs />} />

          <Route path="/add-category/" element={<AddCategory />} />
          <Route path="/all-category/" element={<AllCategory />} />
          <Route path="/edit-category/:slug" element={<EditCategory />} />

          <Route path="/add-product/" element={<AddProduct />} />
          <Route path="/all-product/" element={<AllProduct />} />
          <Route path="/edit-product/:slug" element={<EditProduct />} />

          <Route path="/add-attribute/" element={<AddAttribute />} />
          <Route path="/all-attribute/" element={<AllAttribute />} />
          <Route path="/edit-attribute/:slug" element={<EditAttribute />} />

          <Route path="/add-specialization/" element={<AddSpecialization />} />
          <Route path="/all-specialization/" element={<AllSpecialization />} />
          <Route
            path="/edit-specialization/:slug"
            element={<EditSpecialization />}
          />

          <Route path="/add-skill/" element={<AddSkill />} />
          <Route path="/all-skill/" element={<AllSkill />} />
          <Route path="/edit-skill/:slug" element={<EditSkill />} />

          <Route path="/add-interested/" element={<AddInterested />} />
          <Route path="/all-interested/" element={<AllInterested />} />
          <Route path="/edit-interested/:slug" element={<EditInterested />} />

          <Route path="/add-business/" element={<AddBusiness />} />
          <Route path="/all-business/" element={<AllBusiness />} />
          <Route path="/edit-business/:slug" element={<EditBusiness />} />

          <Route path="/add-department/" element={<AddDepartment />} />
          <Route path="/all-department/" element={<AllDepartment />} />
          <Route path="/edit-department/:slug" element={<EditDepartment />} />

          <Route path="/add-interested/" element={<AddDepartment />} />
          <Route path="/all-department/" element={<AllDepartment />} />
          <Route path="/edit-department/:slug" element={<EditDepartment />} />

          <Route path="/add-tag/" element={<AddTag />} />
          <Route path="/all-tag/" element={<AllTag />} />
          <Route path="/edit-tag/:slug" element={<EditTag />} />
          <Route path="/add-menu" element={<MenuBuilder />} />
          <Route path="/add-footer-menu" element={<FooterMenuBuilder />} />

          <Route path="/home-layout" element={<HomeLayout />} />
          <Route path="/reviews" element={<AllReview />} />
          <Route path="/all-enquire" element={<AllEnquire />} />

          <Route path="/all-order" element={<AllOrder />} />
          <Route path="/pending-order" element={<PendingOrder />} />
          <Route path="/complete-order" element={<CompleteOrder />} />

          <Route path="/order/:userId/:orderId" element={<OrderView />} />

          <Route path="/all-user" element={<AllUser />} />
          
          <Route
            path="/all-seeker"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <AdminUsersPage
                  role="job_seeker"
                  title="Job Seekers"
                  detailPath="/user-job-seeker"
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          {/* <Route path="/all-vendor" element={<AllUserVendor />} /> */}
          <Route
            path="/all-recruiter"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <AdminUsersPage
                  role="recruiter"
                  title="Recruiters"
                  detailPath="/user-recruiter"
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route path="/user/:slug" element={<UserView />} />
          <Route path="/user-vendor/:slug" element={<ProfileVendorView />} />
          <Route
            path="/user-hospital/:slug"
            element={<ProfileHospitalView />}
          />
          <Route path="/user-doctor/:slug" element={<ProfileDoctorView />} />
          <Route
            path="/user-recruiter/:slug"
            element={<ProfileHospitalView />}
          />
          <Route
            path="/user-job-seeker/:slug"
            element={<ProfileDoctorView />}
          />

          <Route path="/theme-setting" element={<ThemeSetting />} />

          <Route path="/add-zones/" element={<AddZones />} />
          <Route path="/all-zones/" element={<AllZones />} />
          <Route path="/edit-zones/:slug" element={<EditZones />} />

          <Route path="/add-taxes/" element={<AddTax />} />
          <Route path="/all-taxes/" element={<AllTax />} />
          <Route path="/edit-taxes/:slug" element={<EditTax />} />

          <Route path="/add-promo/" element={<AddPromo />} />
          <Route path="/all-promo/" element={<AllPromo />} />
          <Route path="/edit-promo/:slug" element={<EditPromo />} />

          <Route path="/add-page/" element={<AddPage />} />
          <Route path="/all-page/" element={<AllPage />} />
          <Route path="/edit-page/:slug" element={<EditPage />} />
          <Route path="/all-images" element={<AllImages />} />

          <Route path="/job-view/:id" element={<JobView />} />
          <Route
            path="/all-job/"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <AdminJobsPage />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/admin/job-approvals"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <AdminJobsPage approvalsOnly />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/admin/applications"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <AdminApplicationsPage />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/admin/database-transfer"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <DatabaseTransfer />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/admin/notifications"
            element={
              isUserAuthenticated && isUsertype === 0 ? (
                <NotificationCenter />
              ) : (
                <Navigate to="/" />
              )
            }
          />
 

<Route
  path="/all-plans/"
  element={
    isUserAuthenticated && isUsertype === 0 ? (
      <AllPlansCard />
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/admin/subscription-orders"
  element={
    isUserAuthenticated && isUsertype === 0 ? (
      <AdminSubscriptionOrdersPage />
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/add-job/"
  element={
    isUserAuthenticated ? (
      <AddJob />
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/all-job-doctor/"
  element={
    isUserAuthenticated ? (
      <AllJobDoctor />
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/my-job"
  element={
    isUserAuthenticated ? (
      <AllJobMyJob />
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route
  path="/add-user"
  element={
    isUserAuthenticated ? (
      <SignupUserType />
    ) : (
      <Navigate to="/" />
    )
  }
/>

<Route path="/register" element={<PublicSignupUser />} />

          <Route path="*" element={<Admin404 />} />
        </Routes>
        <ScrollToTop />
      </ThemeProvider>
    </>
  );
}

export default App;
